export const DEFAULT_PORTAL_BANNER_URL =
  'https://50-journeys-static.s3.eu-west-1.amazonaws.com/public/portal-images/50journeys-portal-banner.png';

export const DEFAULT_COMPANY_LOGO_MOBILE_URL =
  'https://50-journeys-static.s3.eu-west-1.amazonaws.com/public/50logo-Journeys.png';

export const DEFAULT_COMPANY_LOGO_DESKTOP_URL =
  'https://50-journeys-static.s3.eu-west-1.amazonaws.com/public/portal-images/50-journeys-logo-with-name.svg';

export const PUBLIC_EMAIL_DOMAINS = [
  'gmail',
  'googlemail',
  'yahoo',
  'hotmail',
  'outlook',
  'live',
  'msn',
  'aol',
  'icloud',
  'mail',
  'yandex',
  'gmx',
  'protonmail',
  'zoho',
  'comcast',
  'sbcglobal',
  'me',
  'att',
  'bellsouth',
  'rediffmail',
  'cox',
  'fastmail',
  'qq',
  'sina',
  '163',
  '126',
  'naver',
  'daum',
];

export const IMAGE_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.webp',
  '.gif',
  '.heic',
  '.heif',
  '.bmp',
  '.tiff',
  '.tif',
  '.ico',
  '.svg',
];
